import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from '@mui/icons-material/Check';
import { useTheme } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';
import React from 'react';
import ExpandMore from '../shared/ExpandMore.styled';
import styles from './styles';

const EirValidateCollapseTop = ({
  checkMark,
  expanded,
  handleExpandClick,
  numbering,
  text,
  required,
  disableCollapse,
}) => {
  const theme = useTheme();
  return (
    <Grid container spacing={1} margin='auto' sx={styles(theme).gridCollapseDimension}>
      <Grid item container xs={9} md={10} sx={styles(theme).gridText}>
        <Grid
          item
          container
          xs={16}
          direction='row'
          justifyContent='flex-start'
          alignItems='stretch'
          columns={16}
        >
          <Grid item xs={1} sx={styles(theme).bbServiceHeaderNumberContainer}>
            <Typography variant='subtitle2' component='p' sx={styles(theme).bbServiceHeaderNumber}>
              {numbering}
            </Typography>
          </Grid>
          <Grid item xs={15} sx={styles(theme).bbServiceRequired}>
            <Typography variant='subtitle2' component='p' sx={styles(theme).bbServiceHeaderText}>
              {text}
              <Typography variant='subtitle2' component='p' sx={styles(theme).requiredText}>
                &nbsp;{required}
              </Typography>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        xs={1}
        justify='flex-end'
        sx={{ direction: 'rtl', paddingTop: '0px!important' }}
      >
        {checkMark && <CheckIcon sx={{ color: theme.palette.secondary.greenBackground }} />}
      </Grid>
      <Grid
        item
        xs={2}
        md={1}
        sx={disableCollapse ? styles(theme).disableScheduleMove : { paddingTop: '0px!important' }}
      >
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label='show more'
          sx={{ m: '0 auto', height: 24, width: 24, p: 0, display: 'block' }}
        >
          <ExpandMoreIcon sx={{ color: theme.palette.primary.buttonColor }} />
        </ExpandMore>
      </Grid>
    </Grid>
  );
};

export default EirValidateCollapseTop;
